module.exports = __webpack_public_path__ + "51a8467b72e557f39575209c8845d2ef.svg";